module.exports = __webpack_public_path__ + "img/ic_feedback.6a0b6ae0.png";